import React from "react";
import { CSSTransition } from "react-transition-group";
import Button from "../button/button";

const ModalTerms = ({ ifShow, dataDescription, onClose } = props) => {
	return (
		<CSSTransition in={ifShow} timeout={300} classNames="modal">
			<div className="modal-component-wrapper modal-terms">		
				<div className="modal-terms__content">	
						<i className="icon-close" onClick={()=>onClose()}/>
						<div className="modal-terms__content--items">
							<div className="modal-terms__content--description">{dataDescription}</div>
						</div>
						<div className="modal-terms__content--actions">
							<Button onClick={() => onClose()} className="btn btn-secondary-md">
								Ok
							</Button>
						</div>
					</div>
				</div>
		</CSSTransition>
	);
};

export default ModalTerms;
